<template>
  <div class="modal show_modal"  tabindex="-1" role="dialog" v-if="value">
    <div class="modal-dialog modal-dialog-centered" :class="modal">
      <div class="modal-content" >
        <div class="modal-header">
             <slot name="header"></slot>
        </div>
        <div class="modal-body" :style="body">
         <slot name="body"></slot>
        </div>
        <div class="modal-footer text-center">
           <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BaseModal",
  props: {
    value: Boolean,
    modal: String,
    body: String
  },
  methods: {
    close(){
      return this.$emit("input", false);
    }
  },

};
</script>